import { getCookie } from '../data/Cookies';
import { useEffect, useState } from 'react';
import mockApi from '../api/mockApi';

export default function useSuggestion() {

    let id = getCookie("id");

    const defaultSuggestion = {
        hour: 17,
        minutes: 30,
        energy: 20000
    }

    const [suggestion, setSugestion] = useState(defaultSuggestion);

    const [response, setResponse] = useState();

    const getSuggestion = async () => {
        try {
            const responseLocal = await mockApi.get('/getHistory/' + id);
            setResponse(responseLocal);
        } catch (error) {
            console.log(error)
        }
    };

    useEffect(() => {
        const aggregatedHistory = aggregateHistory();
        calculateSuggestion(aggregatedHistory);
    }, [JSON.stringify(response)])

    function aggregateHistory() {
        if (response === undefined) return;
        const keys = Object.keys(response.data);

        var suggestionAggregated = [];
        const now = new Date(Date.now()).getDay();

        keys.forEach((key) => {
            var day = Date.parse(response.data[key].arrival);
            day = new Date(day).getDay();
            if (day === now) {
                suggestionAggregated.push(response.data[key]);
            }
        })

        return suggestionAggregated;
    }

    function calculateSuggestion(aggregatedHistory) {
        if (aggregatedHistory === undefined || aggregatedHistory.length === 0) {
            return defaultSuggestion;
        }

        var energy = [];
        var departures = [];

        for (var i = 0; i != aggregatedHistory.length; i ++) {
            energy.push(aggregatedHistory[i].session_energy);
            departures.push(Date.parse(aggregatedHistory[i].departure));
        }

        const suggestedEnergy = mode(energy);
        const suggestedDeparture = mode(departures);
        const departureDateTime = new Date(suggestedDeparture * 1);

        const newSuggestion = {
            energy: suggestedEnergy,
            hour: departureDateTime.getHours(),
            minutes: departureDateTime.getMinutes()
        }

        setSugestion(newSuggestion);
    }

    function mode(list) {
        var occuranceDictionary = {};

        for (var i = 0; i != list.length; i ++) {
            const listEntry = list[i];
            if (occuranceDictionary[listEntry] === undefined) {
                occuranceDictionary[listEntry] = 0;
            } else {
                occuranceDictionary[listEntry] ++;
            }
        }

        var mostRepetitions = 0;
        var mostRepetitionsKey = 0;
        const keysEnergy = Object.keys(occuranceDictionary);
        keysEnergy.forEach((key) => {
            if (occuranceDictionary[key] >= mostRepetitions) {
                mostRepetitionsKey = key;
                mostRepetitions = occuranceDictionary[key];
            }
        })

        return mostRepetitionsKey;
    }

    return { suggestion: suggestion, getSuggestion: getSuggestion };
}